import React from 'react';

import * as Styled from './popup-menu.style';
import { Colors } from './types';

export type PopupMenuTitleProps = {
  title: string;
  description?: string;
  end?: React.ReactNode;
  isSubTitle?: boolean;
  hasBottomBorder?: boolean;
  compact?: boolean;
};

export const PopupMenuTitle: React.FC<PopupMenuTitleProps> = ({
  title,
  description,
  end,
  isSubTitle,
  hasBottomBorder,
  compact,
}) => (
  <Styled.TitleContainer
    $color={isSubTitle ? Colors.TextSecondary : undefined}
    $hasBottomBorder={!!hasBottomBorder}
    $compact={!!compact}
    $isSubTitle={!!isSubTitle}
  >
    {description ? (
      <Styled.TitleTextContainer>
        <Styled.Title $isSubTitle={!!isSubTitle} $hasDescription>
          {title}
        </Styled.Title>
        <Styled.TitleDescription>{description}</Styled.TitleDescription>
      </Styled.TitleTextContainer>
    ) : (
      <Styled.Title $isSubTitle={!!isSubTitle}>{title}</Styled.Title>
    )}
    {end}
  </Styled.TitleContainer>
);
